export const GA_MEASUREMENT_ID = 'G-56YKG1P68Z'; // UPDATE index.html WHERE THIS VALUE IS DUPLICATED

export const USER_ID_DIMENSION = 'userId';
export const USER_EMAIL_DIMENSION = 'userEmail';
export const PROPERTY_ID_DIMENSION = 'propertyId';
